import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";
import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { communityService }  from "@/services/api/cresivoxServer";

//@ts-ignore
import {iCommunityDTO, REDUCER_NAME} from "./Types";
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

// export const getCommunityList = createAsyncThunk<
//   iGenericResponse<any | null> | null,
//   string, // 👈 vendorId is a string (or change to actual type)
//   {
//     rejectValue: iStateMessage;
//   }
// >(
//   curriedGetThunkName("communityList"),
// //@ts-ignore
//   async (vendorId, { rejectWithValue }) => {
//     try {
//       const response = await communityService.getCommunityList(vendorId);

//       if (response) {
//         const { httpStatusCode, data, message } = response;

//         switch (httpStatusCode) {
//           case httpStatusCodes.SUCCESS_OK: {
//             if (data && data.data) {
//               return {
//                 httpStatusCode,
//                 data: data.data,
//                 message,
//               };
//             } else {
//               return rejectWithValue({
//                 httpStatusCode,
//                 message,
//               });
//             }
//           }
//           default: {
//             return rejectWithValue({
//               httpStatusCode,
//               message,
//             });
//           }
//         }
//       } else {
//         return rejectWithValue({
//           message: "No response received",
//         });
//       }
//     } catch (error) {
//       console.log("🚀 ~ error:", error);
//       return rejectWithValue({
//         message: "Something went wrong",
//       });
//     }
//   }
// );



export const getCommunityList = createAsyncThunk<
  iGenericResponse<any | null> | null,
  void, // 👈 no argument
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("communityList"),
  // @ts-expect-error
  async (_, { rejectWithValue }) => {
    try {
      const response = await communityService.getCommunityList(); // 👈 no param

      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              return {
                httpStatusCode,
                data: data.data,
                message,
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);


export const getAllWholesalerCommunity = createAsyncThunk<
  iGenericResponse<any | null> | null,
{wholesalerId:string},
  {
	  rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getAllWholesalerCommunity"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async ({wholesalerId}, {rejectWithValue}) => {
	  try {
		  const response = await communityService.getWholesalerCommunity(wholesalerId);
		  if (response) {
			  const {httpStatusCode, data, message} = response;

			  switch (httpStatusCode) {
				  case httpStatusCodes.SUCCESS_OK: {
					  if (data && data.data) {
						  return {
							  httpStatusCode,
							  data: data.data,
							  message,
						  };
					  } else {
						  return rejectWithValue({
							  httpStatusCode,
							  message,
						  });
					  }
				  }
				  default: {
					  return rejectWithValue({
						  httpStatusCode,
						  message,
					  });
				  }
			  }
		  } else {
			  return rejectWithValue({
				  message: "No response received",
			  });
		  }
	  } catch (error) {
		  return rejectWithValue({
			  message: "Something went wrong",
		  });
	  }
  },
);

export const getCommunityById = createAsyncThunk<
iGenericResponse<any | null> | null,
{communityId:string},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("getCommunityById"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (arg, {rejectWithValue}) => {
	try {
		const response = await communityService.getCommunityById(arg);
		if (response) {
			const {httpStatusCode, data, message} = response;
			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							   data:{
								community: data.data,
								message,
							   }
							}
						
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const updateCommunity = createAsyncThunk<
iGenericResponse<any | null> | null,
{communityId:string, data: iCommunityDTO },
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("updateCommunity"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({communityId,data}, {rejectWithValue}) => {
	try {
		const response = await communityService.updateCommunity(communityId,data);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								data: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const updateCommunityStatus = createAsyncThunk<
iGenericResponse<any | null> | null,
{communityId:string, status: boolean},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("updateCommunityStatus"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({communityId,status}, {rejectWithValue}) => {
	try {
		const response = await communityService.updateCommunityStatus(communityId,status);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								data: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const deleteCommunity = createAsyncThunk<
iGenericResponse<any | null> | null,
{communityId:string},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("deleteCommunity"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({communityId}, {rejectWithValue}) => {
	try {
		const response = await communityService.deleteCommunity(communityId);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
								data: data.data,
								message,
							
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);


export const createCommunity = createAsyncThunk<
iGenericResponse<any | null> | null,
iCommunityDTO,
{
	rejectValue: iStateMessage;
}
>(


	
curriedGetThunkName("createCommunity"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (payload, {rejectWithValue}) => {
	try {
		const response = await communityService.createCommunity(payload);
		if (response) {
			const {httpStatusCode, data, message} = response;
			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_CREATED: {
					return {
						httpStatusCode,
						data,
						message,
					};
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);



export const getAllWholesalerCommunityWithoughtId = createAsyncThunk<
  iGenericResponse<any> | null, // ✅ Ensure return type matches expected payload
  void, // ✅ No parameter is needed
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getAllWholesalerCommunityWithoughtId"),
  // @ts-expect-error
  async (_, { rejectWithValue }) => {
    try {
      const response = await communityService.getAllWholesalerCommunityWithoutId();

      if (!response) {
        return rejectWithValue({ message: "No response received" });
      }

      const { httpStatusCode, data, message } = response;

      if (httpStatusCode === httpStatusCodes.SUCCESS_OK && data?.data) {
        return {
          httpStatusCode,
          data: data.data, // ✅ Ensure the structure matches iGenericResponse
          message,
        };
      }

      return rejectWithValue({ httpStatusCode, message });
    } catch (error) {
      console.error("🚀 ~ Error fetching wholesaler community:", error);
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);